import React from 'react';
import Icon from 'common/components/Icon';
import useOnClickOutside from 'common/hooks/useOnClickOutside';
import { MenuButton, MenuItem, MenuList, MenuWrapper } from 'modules/settings/components/DataExport/styled';

interface Props {
  /** Accessible name of the "⋯" button. */
  label: string;
  items: { label: string; onSelect: () => void }[];
}

/** A "⋯" button that opens a small menu of the less common row actions (revoke, remove). */
const RowMenu: React.FC<Props> = ({ label, items }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, () => setIsOpen(false));

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') setIsOpen(false);
  };

  return (
    <MenuWrapper ref={ref} onKeyDown={handleKeyDown}>
      <MenuButton type='button' aria-label={label} aria-haspopup='menu' aria-expanded={isOpen} onClick={() => setIsOpen(open => !open)}>
        <Icon icon='more' size={20} color='gray600' />
      </MenuButton>
      {isOpen && (
        <MenuList role='menu'>
          {items.map(({ label: itemLabel, onSelect }) => (
            <MenuItem
              key={itemLabel}
              type='button'
              role='menuitem'
              onClick={() => {
                setIsOpen(false);
                onSelect();
              }}
            >
              {itemLabel}
            </MenuItem>
          ))}
        </MenuList>
      )}
    </MenuWrapper>
  );
};

export default RowMenu;
